<template>
    <v-container class="full-height">
        <span class="loading">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </span>
    </v-container>
</template>
<script>
export default {
    name: "Loader",
};
</script>
<style lang="scss">
$speed: 2.5s;

.full-height {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}

.loading {
    display: block;
    margin: auto;
    position: relative;
    width: 50px;
    height: 50px;

    span {
        display: block;
        position: absolute;
        width: 50%;
        height: 50%;

        &:nth-child(1) {
            top: 0;
            left: 0;

            background-color: rgba(#FF931E, .75);

            animation: move1 $speed linear infinite;
        }

        &:nth-child(2) {
            top: 0;
            right: 0;

            background-color: rgba(#2890FB, .75);

            animation: move2 $speed linear infinite;
        }

        &:nth-child(3) {
            bottom: 0;
            left: 0;

            background-color: rgba(#672178, .75);

            animation: move3 $speed linear infinite;
        }

        &:nth-child(4) {
            bottom: 0;
            right: 0;

            background-color: rgba(#2181B7, .75);

            animation: move4 $speed linear infinite;
        }
    }
}

@keyframes move1 {
    0% {
        transform: translate(0);
        z-index: 10;
    }

    25% {
        transform: translate(100%, 0);
    }

    50% {
        transform: translate(100%, 100%);
    }

    75% {
        transform: translate(0, 100%);
        z-index: 0;
    }

    100% {
        transform: translate(0);
    }
}

@keyframes move2 {
    0% {
        transform: translate(0);
    }

    25% {
        transform: translate(0, 100%);
    }

    50% {
        transform: translate(-100%, 100%);
        z-index: 0;
    }

    75% {
        transform: translate(-100%, 0);
        z-index: 10;
    }

    100% {
        transform: translate(0);
    }
}

@keyframes move3 {
    0% {
        transform: translate(0);
    }

    25% {
        transform: translate(0, -100%);
        z-index: 10;
    }

    50% {
        transform: translate(100%, -100%);
    }

    75% {
        transform: translate(100%, 0);
    }

    100% {
        transform: translate(0);
        z-index: 0;
    }
}

@keyframes move4 {
    0% {
        transform: translate(0);
    }

    25% {
        transform: translate(-100%, 0);
        z-index: 0;
    }

    50% {
        transform: translate(-100%, -100%);
        z-index: 10;
    }

    75% {
        transform: translate(0, -100%);
    }

    100% {
        transform: translate(0);
    }
}
</style>